export enum ModalZone {
	primary = "primary",
	secondary = "secondary",
	tercary = "tercary",
}

export enum ModalKeys {
	wallet = "layout-wallet-modal",
	basket = "layout-basket-modal",
	productInfo = "product-info",
	campaignTakeOfflineConfirmation = "campaign-confirm-take-offline",
	campaignProductTakeOfflineConfirmation = "campaign-product-confirm-take-offline",
	campaignCopyJourney = "campaign-confirm-copy",
	campaignStatusDetail = "campaign-status-detail",
	campaignCopySelection = "contract-copy-selection",
	campaignEdit = "campaign-edit",
	basketRemoveProductConfirmation = "remove-product-from-basket",
	basketProductBundleParentClashConfirmation = "basket-product-bundle-parent-clash-confirmation",
	basketProductBundleChildClashConfirmation = "basket-product-bundle-child-clash-confirmation",
	basketProductCPAClashConfirmation = "basket-product-cpa-clash-confirmation",
	contractRemoveConfirmation = "contract-remove-confirmation",
	contractGroupRemoveConfirmation = "contract-group-remove-confirmation",
	contractGroupUpdateConfirmation = "contract-group-update-confirmation",
	contractEdit = "contract-edit",
	contractGroupConflictInfo = "contract-group-conflict-info",
	filePicker = "file-picker",
	mediaEditor = "media-editor",
	uploadWidget = "upload-widget",
	mediaLibrary = "media-library",
}

export enum FilePickerModalPropsActionFor {
	postingOrganization = "posting-organization",
	productPostingRequirements = "product-posting-requirements",
	contractPostingRequirements = "contract-posting-requirements",
}
